import i18n from "i18next";
import { getLocaleMonthName } from "../utils/stringUtil";
import { SelectDataModel } from "../components/arc/ArcSelectbox";

export class VariablesConstant {
  public static readonly YES_NO = [
    { label: i18n.t("confirm.button.yes.text"), value: "Y" },
    { label: i18n.t("confirm.button.no.text"), value: "N" },
  ];

  public static readonly PAGE_PER_LIST = [
    { label: `10${i18n.t("common.unit.piece")}`, value: 10 },
    { label: `20${i18n.t("common.unit.piece")}`, value: 20 },
    { label: `30${i18n.t("common.unit.piece")}`, value: 30 },
  ];

  public static readonly CP_DOCU_BIZ_STATUS = [
    {label: "신청", value: "신청"},
    {label: "심의승인", value: "심의승인"},
    {label: "심의반려", value: "심의반려"},
    {label: "착수신고", value: "착수신고"},
    {label: "문서 재제출 요청", value: "문서 재제출 요청"}
  ];

  public static readonly OT_CATEGORY = [
    { label: i18n.t("ot.board.searchOptionBasic"), value: "1" },
    { label: i18n.t("ot.board.searchOptionRequest"), value: "2" },
  ];

  public static readonly OT_TRD_PROGRESS = [
    { label: '거래 진행 중', value: "1" },
    { label: '거래 종료', value: "2" },
  ];

  public static readonly OT_TRD_LIST_ASC = [
    { label: '등록일 순', value: "regDate" },
    { label: '거래량 순', value: "trdQnt" },
  ];

  public static readonly OT_TRD_REC_PGMTL = [
    { label: '태양광', value: '태양광' },
    { label: '풍력', value: '풍력' },
  ];

  public static readonly OT_TRD_APL_STS_CD = [
    { label: i18n.t('common.code.trdAplStsCd.0'), value: '0' },
    { label: i18n.t('common.code.trdAplStsCd.1'), value: '1' },
    { label: i18n.t('common.code.trdAplStsCd.2'), value: '2' },
    { label: i18n.t('common.code.trdAplStsCd.3'), value: '3' },
    { label: i18n.t('common.code.trdAplStsCd.4'), value: '4' },
    { label: i18n.t('common.code.trdAplStsCd.5'), value: '5' },
    { label: i18n.t('common.code.trdAplStsCd.6'), value: '6' },
    { label: i18n.t('common.code.trdAplStsCd.7'), value: '7' },
    { label: i18n.t('common.code.trdAplStsCd.9'), value: '9' },
  ];

  public static readonly OT_CNTR_CD = [
    { label: i18n.t('common.label.total'), value: '0' },
    { label: i18n.t('common.code.cntrCd.1'), value: '1' },
    { label: i18n.t('common.code.cntrCd.2'), value: '2' },
    { label: i18n.t('common.code.cntrCd.3'), value: '3' },
  ]

  public static readonly OT_REPORT_SEARCH = [
    {label: i18n.t('common.label.title'), value: 'titlNm'},
    {label: i18n.t('common.label.content'), value: 'ctt'},
  ];

  public static readonly OT_REPORT_CODE = [
    {label: i18n.t('common.code.rpdcCd.1'), value: "1"},
    {label: i18n.t('common.code.rpdcCd.2'), value: "2"},
    {label: i18n.t('common.code.rpdcCd.3'), value: "3"},
  ]

  public static readonly OT_REQD_PBLS_YN = [
    { label: '발행', value: 'Y' },
    { label: '미발행', value: 'N' },
  ];

  public static readonly OT_REQD_SETL_STATUS = [
    { label: '발행 대기', value: '1'},
    { label: '결제 대기', value: '2' },
    { label: '결제 완료', value: '3' },
    { label: '납부기한 경과', value: '4' },
  ];

  public static readonly OT_LDSP_TRD_CD = [
    { label: i18n.t('common.code.emksLdspTrdClCd.1'), value: '1' },
    { label: i18n.t('common.code.emksLdspTrdClCd.2'), value: '2' },
  ];

  public static readonly RE100_ENT_CL_CD = [
    { label: '대기업', value: 'ECOM001' },
    { label: '중견기업', value: 'ECOM002' },
    { label: '중소기업', value: 'ECOM003' }
  ];

  public static readonly Y_N = [
    { label: "Y", value: "Y" },
    { label: "N", value: "N" },
  ];

  public static readonly GENDER = [
    { label: "Active", value: "Y", labelKr: "활성화" },
    { label: "Inactive", value: "N", labelKr: "비활성화" },
  ];

  public static readonly MENU_STATUS = [
    { label: "Active", value: "Y", labelKr: "활동적인" },
    { label: "Inactive", value: "N", labelKr: "멈추다" },
  ];

  public static readonly DEFAULT_MENU_STATUS = "N";

  public static readonly DEFAULT_COMM_CODE_STATUS = "N";

  public static readonly MONTH = [
    { label: getLocaleMonthName(1), value: "1" },
    { label: getLocaleMonthName(2), value: "2" },
    { label: getLocaleMonthName(3), value: "3" },
    { label: getLocaleMonthName(4), value: "4" },
    { label: getLocaleMonthName(5), value: "5" },
    { label: getLocaleMonthName(6), value: "6" },
    { label: getLocaleMonthName(7), value: "7" },
    { label: getLocaleMonthName(8), value: "8" },
    { label: getLocaleMonthName(9), value: "9" },
    { label: getLocaleMonthName(10), value: "10" },
    { label: getLocaleMonthName(11), value: "11" },
    { label: getLocaleMonthName(12), value: "12" },
  ];

  public static readonly TGT = [
    { label: "태양광", value: "태양광" },
    { label: "풍력", value: "풍력" },
    { label: "수력", value: "수력" },
    { label: "바이오", value: "바이오" },
    { label: "지열", value: "지열" },
    { label: "해양", value: "해양" },
  ];

  public static readonly MB = [
    {label: "참여", value: "0"},
    {label: "미참여", value: "1"},
    {label: "관심", value: "2"},
  ]

  public static readonly INDS_CMPLX_OPTIONS = [
    { label: "전체", value: "" },
    { label: "1단지", value: "INDS001" },
    { label: "2단지, 3단지", value: "INDS002" },
    { label: "4단지", value: "INDS004" },
    { label: "5단지", value: "INDS005" },
  ];

  public static readonly INDS_CMPLX_EXCEPTALL = [
    { label: "1단지", value: "INDS001" },
    { label: "2단지, 3단지", value: "INDS002" },
    { label: "4단지", value: "INDS004" },
    { label: "5단지", value: "INDS005" },
  ];

  public static readonly INDS_CMPLX_EXCEPTALL_DB = [
    { label: "1단지: 방위산업 특화지구", value: "INDS001" },
    { label: "2단지, 3단지: 반도체 특화지구", value: "INDS002" },
    { label: "4단지: 메타버스 특화지구", value: "INDS004" },
    { label: "5단지: 이차전지 특화지구", value: "INDS005" },
  ];

  public static readonly INDS_CMPLX_STRICT_OPTIONS = [
    { label: "1단지", value: "INDS001" },
    { label: "2단지", value: "INDS002" },
    { label: "3단지", value: "INDS003" },
    { label: "4단지", value: "INDS004" },
    { label: "5단지", value: "INDS005" },
  ];

  public static readonly SELECT_OPTIONS_ALL_DATE: SelectDataModel[] = [
    { label: "연도별", value: "year" },
    { label: "연간", value: "month" },
    { label: "월간", value: "day" },
    { label: "일간", value: "date" },
  ];
  public static readonly SELECT_OPTIONS_YEAR_MONTH_DAY: SelectDataModel[] = [
    { label: "연도별", value: "year" },
    { label: "연간", value: "month" },
    { label: "월간", value: "day" },
  ];
  public static readonly SELECT_OPTIONS_MONTH_DAY: SelectDataModel[] = [
    { label: "연간", value: "month" },
    { label: "월간", value: "day" },
  ];
  public static readonly SELECT_OPTIONS_YEARLY_MONTHLY: SelectDataModel[] = [
    { label: "연도별", value: "year" },
    { label: "연간", value: "month" },
  ];
  public static readonly SELECT_OPTIONS_YEARLY: SelectDataModel[] = [
    { label: "연간", value: "month" },
  ];
  public static readonly SELECT_OPTIONS_MONTH_DAY_DATE: SelectDataModel[] = [
    { label: "연간", value: "month" },
    { label: "월간", value: "day" },
    { label: "일간", value: "date" },
  ];
  public static readonly SELECT_OPTIONS_LVH: SelectDataModel[] = [
    { label: "전체", value: "" },
    { label: "고압", value: "고압" },
    { label: "저압", value: "저압" },
  ];
  public static readonly SELECT_OPTIONS_ENERGY: SelectDataModel[] = [
    { label: "전기", value: "E" },
  ];

  public static readonly SCOPE = [
    { label: "전체", value: "all" },
    { label: "Scope1", value: "SCOPE1" },
    { label: "Scope2", value: "SCOPE2" },
    { label: "Scope3", value: "SCOPE3" },
  ];

  public static readonly BILL_TRD_SORT = [
    {label: i18n.t('common.label.total'), value: '0'},
    {label: i18n.t('common.code.emksReqdCd.1'), value: '1'},
    {label: i18n.t('common.code.emksReqdCd.2'), value: '2'},
    {label: i18n.t('common.code.emksReqdCd.3'), value: '3'},
    {label: i18n.t('common.code.emksReqdCd.4'), value: '4'},
  ];

  public static readonly BILL_SETL = [
    {label: i18n.t('cb.bill.status.1'), value: 1},
    {label: i18n.t('cb.bill.status.2'), value: 2}
  ]

  public static readonly BILL_PBLS_YN = [
    {label: i18n.t('cb.bill.reqdPbls.n'), value: 'N'},
    {label: i18n.t('cb.bill.reqdPbls.y'), value: 'Y'}
  ];

  public static readonly BILL_TXBL_YN = [
    {label: i18n.t('cb.bill.txblYn.n'), value: 'N'},
    {label: i18n.t('cb.bill.txblYn.y'), value: 'Y'}
  ];

  public static readonly OPEN_API_CL_CD = [
    {label: i18n.t('common.code.emksApiClCd.RP'), value: 'RP'},
    {label: i18n.t('common.code.emksApiClCd.CP'), value: 'CP'},
    {label: i18n.t('common.code.emksApiClCd.OT'), value: 'OT'},
    {label: i18n.t('common.code.emksApiClCd.MNG'), value: 'MNG'},
    {label: i18n.t('common.code.emksApiClCd.ETC'), value: 'ETC'},
  ];

  public static readonly OT_OTSD_RSRC_CL_NM = [
    { label: '개별', value: '개별' },
    { label: '집합', value: '집합' },
  ];

  public static readonly WP_WKLY_CK_RSLT = [
    {label: "양호", value: "양호"},
    {label: "미흡", value: "미흡"},
  ];

  public static readonly RP_PWPL_TYPE = [
    { label: '상계거래', value: '01' },
    { label: 'APT열병합발전', value: '02' },
    { label: 'PPA', value: '03' },
    { label: '배전설비', value: '04' },
    { label: '보완공급', value: '05' },
    { label: '송전설비', value: '06' },
    { label: '단순병렬', value: '07' },
    { label: '기타', value: '99' },
  ];

  public static readonly CO_CUST_KND = [
    { label: '부하고객', value: '1' },
    { label: '발전고객', value: '2' },
  ];

  public static readonly EMKS_CNTR_KND_CD = [

    { value: '2000', label: '일반용(갑)I_저압' },
    { value: '2010', label: '일반용(갑)I_고압A_선택I' },
    { value: '2011', label: '일반용(갑)I_고압A_선택II' },
    { value: '2020', label: '일반용(갑)I_고압B_선택I' },
    { value: '2021', label: '일반용(갑)I_고압B_선택II' },
    { value: '2100', label: '일반용(갑)II_고압A_선택I' },
    { value: '2101', label: '일반용(갑)II_고압A_선택II' },
    { value: '2110', label: '일반용(갑)II_고압B_선택I' },
    { value: '2111', label: '일반용(갑)II_고압B_선택II' },
    { value: '2200', label: '일반용(을)_고압A_선택I' },
    { value: '2201', label: '일반용(을)_고압A_선택II' },
    { value: '2202', label: '일반용(을)_고압A_선택III' },
    { value: '2210', label: '일반용(을)_고압B_선택I' },
    { value: '2211', label: '일반용(을)_고압B_선택II' },
    { value: '2212', label: '일반용(을)_고압B_선택III' },
    { value: '3000', label: '산업용(갑)I_저압' },
    { value: '3010', label: '산업용(갑)I_고압A_선택I' },
    { value: '3011', label: '산업용(갑)I_고압A_선택II' },
    { value: '3020', label: '산업용(갑)I_고압B_선택I' },
    { value: '3021', label: '산업용(갑)I_고압B_선택II' },
    { value: '3100', label: '산업용(갑)II_고압A_선택I' },
    { value: '3101', label: '산업용(갑)II_고압A_선택II' },
    { value: '3110', label: '산업용(갑)II_고압B_선택I' },
    { value: '3111', label: '산업용(갑)II_고압B_선택II' },
    { value: '3200', label: '산업용(을)_고압A_선택I' },
    { value: '3201', label: '산업용(을)_고압A_선택II' },
    { value: '3202', label: '산업용(을)_고압A_선택III' },
    { value: '3210', label: '산업용(을)_고압B_선택I' },
    { value: '3211', label: '산업용(을)_고압B_선택II' },
    { value: '3212', label: '산업용(을)_고압B_선택III' },
    { value: '3220', label: '산업용(을)_고압C_선택I' },
    { value: '3221', label: '산업용(을)_고압C_선택II' },
    { value: '3222', label: '산업용(을)_고압C_선택III' },
    { value: '4000', label: '교육용(갑)_저압' },
    { value: '4010', label: '교육용(갑)_고압A_선택I' },
    { value: '4011', label: '교육용(갑)_고압A_선택II' },
    { value: '4020', label: '교육용(갑)_고압B_선택I' },
    { value: '4021', label: '교육용(갑)_고압B_선택II' },
    { value: '4100', label: '교육용(을)_고압A_선택I' },
    { value: '4101', label: '교육용(을)_고압A_선택II' },
    { value: '4110', label: '교육용(을)_고압B_선택I' },
    { value: '4111', label: '교육용(을)_고압B_선택II' },
  ];

  public static readonly FACILITY_TYPE = [
    { label: '인버터', value: '1' },
    { label: '냉난방기', value: '2' },
    { label: '컴프레셔', value: '3' },
    { label: '냉동기', value: '4' },
    { label: '환기팬', value: '5' },
    { label: '전등', value: '6' },
  ];
}
